module.exports = __webpack_public_path__ + "static/img/error-icon.d0b8476.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/error-icon.png
// module id = sHf7
// module chunks = 0